<template>
  <cc-container class="apply-for-return">
    <cc-header-nav title="申请退货"></cc-header-nav>
    <cc-main>
      <cc-card>
        <div class="form">
          <van-cell-group>
            <van-field
              v-if="detail.order_amount > 0"
              v-model="price"
              required
              clearable
              label="退款金额："
              type="number"
              @blur="handleBlur"
              placeholder="请输入退款金额"  />
              <div>
                <van-field
                  v-model="reason"
                  required
                  clearable
                  ref="reason"
                  @focus="showActionSheet = true; $refs.reason.blur()"
                  label="退货原因："
                  placeholder="请选择退货原因"  />
              </div>
            <van-field
              v-model="desc"
              clearable
              label="退货说明："
              type="textarea"
              autosize
              rows="3"
              placeholder="请输入退货说明"  />
          </van-cell-group>
        </div>
      </cc-card>

      <cc-card>
        <product-list @change="handleChange" :stepper="true" :list="goods">

        </product-list>
      </cc-card>

      <section class="summary-box">
        <div>
          <p class="pl10">
            本单总合计：<span class="price">￥{{summaryPrice}}</span>
          </p>
        </div>
        <div>
          <van-button
            style="background: #1BB0D9;border-color: #1BB0D9;"
            size="small"
            type="primary"
            @click="submit"
          >提交申请</van-button>
        </div>
      </section>

      <van-actionsheet
        v-model="showActionSheet"
        :actions="actions"
        @select="onSelect"
      />
    </cc-main>
    <cc-footer>
      <cc-nav>

      </cc-nav>
    </cc-footer>

  </cc-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { Actionsheet, Field, CellGroup, Toast } from 'vant'
import ProductList from '../components/product-list'
import { types } from '../../../../store/modules/order'
Vue.use(Actionsheet).use(Field).use(CellGroup).use(Toast)
export default {
  name: 'apply-for-return',
  components: {
    ProductList
  },
  data () {
    return {
      detail: {},
      goods: [],
      showActionSheet: false,
      actions: [],
      reason: '',
      price: '',
      desc: '',
      // 总计价格
      summaryPrice: 0,
      fromId: this.$route.query.from_id,
      goodsIds: this.$route.query.goods_ids.split(','),
      type: this.$route.query.type
    }
  },
  computed: {
    ...mapGetters(['getSubmitInfo', 'submitReturn'])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions([types.GET_SUBMIT_INFO, types.SUBMIT_RETURN]),
    async loadData () {
      const type = this.type
      const fromId = this.fromId
      const goodsIds = this.goodsIds
      const ids = {}
      goodsIds.map(id => {
        ids[id] = 0
      })
      await this.GET_SUBMIT_INFO({
        type,
        from_id: fromId,
        goods_ids: ids
      })
      this.getSubmitInfo.data.reason.map(reason => {
        this.actions.push({
          name: reason
        })
      })
      this.detail = this.getSubmitInfo.data
      // this.price = this.detail.order_amount
      this.goods = this.getSubmitInfo.data.outbound_goods
      // this.calcSummaryPrice()
      let price = 0
      this.goods.reduce((prev, curr) => {
        price += Number(curr.price * curr.quantity)
      }, {})
      this.summaryPrice = price
    },
    onSelect ({ name }) {
      this.reason = name
      this.showActionSheet = false
    },
    handleBlur () {
      if (+this.price > this.summaryPrice) {
        Toast('退款金额不能超过订单支付金额')
        this.price = this.summaryPrice
      }
    },
    calcSummaryPrice () {
      let price = 0
      this.goods.reduce((prev, curr) => {
        price += +(curr._number * curr.price).toFixed(2)
      }, {})
      this.summaryPrice = price
    },
    handleChange (item) {
      this.calcSummaryPrice()
    },
    /**
     * @description 提交申请
     */
    async submit () {
      if (this.reason === '') {
        Toast('请选择退货原因')
        return
      }
      if (this.getSubmitInfo.data.order_amount > 0 && this.price === '') {
        Toast('请输入退款金额')
        return
      }
      let goodsIds = {}
      this.goods.map(item => {
        goodsIds[item.id] = item._number
      })
      await this.SUBMIT_RETURN({
        from_id: this.fromId,
        price: this.price || 0,
        reason_desc: this.desc,
        reason_info: this.reason,
        goods_ids: goodsIds
      })
      this.$tips(this.submitReturn, {
        tip: true,
        duration: 1500
      }, () => {
        setTimeout(() => {
          this.$router.replace('/order/return')
        }, 2000)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/index.scss';
.apply-for-return {
  .form {
    &-item {
      line-height: 38px;
    }
  }
  .summary-box {
    @include flex(row);
    align-items: center;
    box-shadow: $box-shadow-base;
    background: #fff;
    height: 40px;
    margin-top: 8px;
    margin-bottom: 10px;
    justify-content: space-between;
    padding-right: 10px;
    .checkbox {
      padding-left: 5px;
    }
    .price {
      color: $price-color;
      font-size: 14px;
      line-height: 1;
    }
    .count {
      color: $heading-color;
      font-size: 12px;
      line-height: 1;
    }
  }
}
</style>
